module.exports = __webpack_public_path__ + "img/piece_mincho_a_2k.d6356b97.png";